<mat-form-field class="search-big">
    <input matInput placeholder="Search" (ngModelChange)="performSearch($event)" ngModel #searchit>
</mat-form-field>
<div *ngIf="searchTerm">
    <mat-toolbar class="highlight">Products</mat-toolbar>
    <products></products>

    <mat-toolbar class="highlight">Blog Posts</mat-toolbar>
    <posts></posts>
</div>